import { Component, OnInit } from '@angular/core';
import { AppSettings, LoaderService } from '../core/index';

import { Router } from '@angular/router';
import { SecurityService } from '@xpo/security';
import { AppMessageService } from '../shared/index';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  public title: string = 'XPO Logistics XPO AUTH';
  public version: string = 'v3.1.0';
  public headerMenu: any = [];
  public footerMenu: any = [];
  public showLoader: boolean;
  public displayName: string = null;

  constructor(
    appSettings: AppSettings,
    private router: Router,
    private loaderService: LoaderService,
    private securityService: SecurityService,
    public messageService: AppMessageService,
  ) {
    this.title = appSettings.title;
    this.version = appSettings.version;
    this.headerMenu = appSettings.menus.header;
    this.footerMenu = appSettings.menus.footer;

    this.securityService.user.subscribe((x) => {
      // if x is undefined then app is no longer authenticated
      this.loaderService.display(!x);
      if (x) {
        this.displayName = x.firstName + ' ' + x.lastName;
      }
    });

    this.securityService.postSignoutEvent.subscribe(() => {
      this.loaderService.display(false);
      this.router.navigate(['signedout']);
    });
  }

  public ngOnInit() {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    });

    this.loaderService.display(!this.securityService.isAuthenticated);
  }

  public signOut() {
    this.securityService.signOut();
    this.messageService.loggedOut();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts